import { ReminderNotificationConfigMeta } from '../model/ReminderNotificationConfigMeta';

export const REMINDER_NOTIFICATION_CONFIG_V1_NAME = 'REMINDER_NOTIFICATION_CONFIG_V1';

export type ReminderNotificationMetaV1 = {
  [REMINDER_NOTIFICATION_CONFIG_V1_NAME]?: ReminderNotificationConfigMeta;
};
